import { SUBTITLE_ICONS } from "../icons";
import { TEXT_DARK } from "../theme";

// Renders an equipped "subtitle" item next to a display name. Shared by
// every place a name shows up (menu, profile, leaderboard) so icon/italic/
// color customization is consistent everywhere instead of being re-derived
// per screen.
function SubtitleBadge({ item }) {
  if (!item) return null;
  const Icon = item.config?.icon ? SUBTITLE_ICONS[item.config.icon] : null;
  const color = item.config?.color || TEXT_DARK;
  return (
    <span style={{
      display: "inline-flex",
      alignItems: "center",
      gap: "3px",
      fontSize: "0.6875rem",
      fontWeight: "700",
      fontStyle: item.config?.italic ? "italic" : "normal",
      color,
    }}>
      {Icon && <Icon size={11} color={color} />}
      {item.config?.text}
    </span>
  );
}

export default SubtitleBadge;
